/**
 * This method does nothing and returns undefined.
 *
 * @example
 * noop()
 * // => undefined
 *
 * @function noop
 */
export default function noop() {
	// No operation performed.
}
